import Rails from '@rails/ujs';
Rails.start();

// Stimulus (Hotwire) — client behaviour, fully migrated from jQuery.
import './controllers';
